<template>

    <div class="route-login">

        <div class="content">
            <div class="content-holder">

                <div class="logos-holder">
                    <div class="logo">
                        <i class="img logo-aveco-color-180"></i>
                    </div>
                </div>

                <template v-if="!finished">

                    <h1>Wachtwoord vergeten</h1>
                    <span class="subtitle">Ben je je wachtwoord vergeten? Voer je e-mail adres in en er zal een e-mail worden gestuurd met daarin een knop om een nieuw wachtwoord in te stellen.</span>

                    <form @submit.prevent="submit">

                        <cms-input type="email" name="email" placeholder="E-mail adres" v-model="email"
                                   v-validate="'required|email'" data-vv-as="E-mail adres" :error="error('email')"></cms-input>

                        <cms-button :loading="submitting" @click="submit">Verzenden</cms-button>
                        <input type="submit" style="display: none" />
                    </form>
                    </template>

                <template v-else>

                    <h1>E-mail verzonden</h1>
                    <span class="subtitle">Als je e-mail adres bekend is, is er zojuist een e-mail verzonden met daarin een knop om een nieuw wachtwoord in te stellen.</span>

                </template>

                <div class="nav-link">
                    <router-link :to="{ name: 'login' }">Terug</router-link>
                </div>

            </div>
        </div>

        <toast-container></toast-container>

    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'vue'

    import validationMixin from '@wittignl/js-core/mixins/validation'
    import UserPasswordRequestMutations from "app/mutations/UserPasswordRequestMutations";

    @Component({

        name: 'ForgotPassword',
        mixins: [validationMixin]
    })
    export default class ForgotPassword extends Vue
    {
        submitting = false;
        submitted = false;
        finished = false;

        email = null;

        mounted(){

            this.logger = this.$di.logger.child('ForgotPassword');
            this.logger.info('Mounted');
        }

        async submit(){

            this.submitted = true;

            const success = await this.$validator.validateAll();
            if (!success) {

                this.$toast.warning('Niet alle velden zijn correct ingevuld');
                return;
            }

            this.submitting = true;

            try {

                await UserPasswordRequestMutations.forgotPassword(this.email);
                this.finished = true;
            }
            catch(e){

                this.logger.error(e);
                this.$toast.error('Kon niet verzenden, probeer het opnieuw')
            }

            this.submitting = false;
        }
    }

</script>
